'use client'

import { useEffect, useState } from 'react'
import {
  Anchor,
  H3,
  Separator,
  Stack,
  useTheme,
  XStack,
  YStack,
  Text
} from 'tamagui'
import { Spacer } from './common/Spacer'
import { useDataStore } from '@/contexts/DataStoreContext'
import { LockIcon } from './common/LockIcon'
import { Button } from './common/Button'
import { initializeAptoSdk } from '@services/apto'
import { Marqeta } from '@services/marqeta'

export function PinUpdate() {

  const { session: { data } } = useDataStore()
  const [aptoIssued, setAptoIssued] = useState(undefined)
  
  useEffect(() => {
    if (!data.hasOwnProperty('one_time_token')) {
      setAptoIssued(true)
    } else if (data.hasOwnProperty('one_time_token')) {
      setAptoIssued(false)
    }
  }, [data])

  // Initialize SDK after component has mounted
  useEffect(() => {
    if (aptoIssued) {
      initializeAptoSdk(data)
    }
  }, [aptoIssued, data])

  const theme = useTheme()
  const embedComponent = aptoIssued === false ?
    <Marqeta data={data} type="marqeta.set-pin" /> :
    <Stack
      id="pci-sdk"
      borderRadius="$3"
      overflow="hidden"
    />

  return (
    <YStack justifyContent='center' alignItems='center' flex={1} p={24} pt={0}>
      <YStack space={40} maxWidth={600}>
        <XStack alignItems='center' justifyContent='center' space="$3">
          <LockIcon />
          <H3 textAlign="center">
            <Text>Secure PIN Update</Text>
          </H3>
        </XStack>
        <YStack space="$4" alignItems='center'>
          { embedComponent }

          <Spacer />
          <YStack alignItems='center' justifyContent='center' space="$5" width="100%">

            <Separator w="100%"/>

            <Spacer size="$1"/>

            <Text fontStyle="italic" color="$gray10" fontSize={14}>Having trouble?</Text>

            <Anchor href="mailto:hey@extra.app" target="_blank"><Button size="$3">Email Concierge</Button></Anchor>
          </YStack>

        </YStack>

      </YStack>

    </YStack>
  )
}
